(ns dashboard.views.settings.calendars
  (:require
   [reagent.core :as reagent]
   [re-frame.core :as re-frame]
   [dashboard.i18n :refer [tr]]
   [dashboard.subs :as subs]
   [dashboard.utils :refer [listen vec-remove index-of]]
   [dashboard.events.calendars :as calendar-events]
   [dashboard.components.drawer :refer [drawer]]
   [dashboard.components.dialog :refer [dialog]]
   [dashboard.components.button :refer [button]]
   [dashboard.components.inputs :refer [input]]
   [dashboard.components.table :refer [table]]
   [dashboard.components.tag :refer [tag]]
   [dashboard.components.radiogroup :refer [color-circle color-group]]
   ["date-fns" :refer [formatISO formatDistance]]
   ["@heroicons/react/solid" :refer [XIcon PencilIcon]]))

(defn- calendar-drawer-content [{:keys [state dialog-state]}]
  (let [default-tag {:id (str (random-uuid))
                     :name ""
                     :color "red"}
        default-status {:id (str (random-uuid))
                        :name ""
                        :color "red"}]
    [:div.relative.mt-6.flex-1.px-4.sm:px-6

     [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
      [:div
       [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
        (tr :calendar/name)]]
      [:div.sm:col-span-3
       [input
        {:auto-complete "name"
         :name "name"
         :type "text"
         :disabled? (= (:action @state) :view)
         :default-value (get-in @state [:calendar :name])
         :on-change #(swap! state assoc-in [:calendar :name] %)}]]]

     [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
      [:div
       [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
        (tr :calendar/nameJp)]]
      [:div.sm:col-span-3
       [input
        {:auto-complete "name"
         :name "name"
         :type "text"
         :disabled? (= (:action @state) :view)
         :default-value (get-in @state [:calendar :nameJp])
         :on-change #(swap! state assoc-in [:calendar :nameJp] %)}]]]

     [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-3
      [:div
       [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
        (tr :calendar/color)]]
      [:div.sm:col-span-3.flex.space-x-2
       [color-group
        {:class "flex"
         :selected (get-in @state [:calendar :color])
         :on-change #(swap! state assoc-in [:calendar :color] %)
         :size 4
         :colors (listen ::subs/colors)}]]]

     [:div.py-2.mt-3
      [:div.flex.justify-between.items-center
       [:label.block.text-sm.font-medium.text-gray-700
        (tr :tags)]
       [button
        {:disabled? (= (:action @state) :view)
         :small? true
         :on-click #(reset! dialog-state {:is-open? true
                                          :tag default-tag
                                          :action :add})}
        (tr :action/add)]]
      [:div.-mx-4.mt-2.flex.flex-col.sm:-mx-6.md:mx-0.mb-4
       [:table.divide-y.divide-gray-300
        [:thead
         [:tr
          [:th.pl-4.pr-3.text-left.text-sm.font-semibold.text-gray-900.sm:pl-6.md:pl-0
           {:class "py-2.5"
            :scope "col"}
           (tr :calendar.tag/name)]
          [:th.pr-3.text-right.text-sm.font-semibold.text-gray-900
           {:class "py-2.5"
            :scope "col"}
           (tr :action/edit)]]]
        [:tbody
         (if (not (empty? (get-in @state [:calendar :eventTags])))
           (doall
            (for [[idx event-tag] (->> (get-in @state [:calendar :eventTags])
                                       (map-indexed vector))]
              ^{:key (:id event-tag)}
              [:tr.divide-x
               [:td.py-1.px-2.font-semibold.text-sm.flex.items-center
                [tag
                 {:interactive? true
                  :color (:color event-tag)}
                 (:name event-tag)]]
               [:td.whitespace-nowrap.py-1.pl-2.text-right.text-sm.font-medium.pr-3.w-12
                [:button.text-primary-600.hover:text-primary-900
                 {:type "button"
                  :on-click #(reset! dialog-state {:is-open? true
                                                   :tag event-tag
                                                   :action :edit})}
                 [:> PencilIcon
                  {:class "h-4 w-4"
                   :aria-hidden true}]]
                [:button.text-primary-600.hover:text-primary-900
                 {:type "button"
                  :on-click #(swap! state assoc-in [:calendar :eventTags]
                                    (vec-remove (into [] (get-in @state [:calendar :eventTags])) idx))}
                 [:> XIcon
                  {:class "h-4 w-4"
                   :aria-hidden true}]]]]))
           [:tr.divide-x
            [:td.py-1.px-2.text-sm.flex.items-center
             {:scope "row"
              :colSpan 2}
             "No tags"]])]]]]

     [:div.py-2.mt-3
      [:div.flex.justify-between.items-center
       [:label.block.text-sm.font-medium.text-gray-700
        (tr :calendar/status)]
       [button
        {:disabled? (= (:action @state) :view)
         :small? true
         :on-click #(reset! dialog-state {:is-open? true
                                          :status default-status
                                          :action :add})}
        (tr :action/add)]]
      [:div.-mx-4.mt-2.flex.flex-col.sm:-mx-6.md:mx-0.mb-4
       [:table.divide-y.divide-gray-300
        [:thead
         [:tr
          [:th.pl-4.pr-3.text-left.text-sm.font-semibold.text-gray-900.sm:pl-6.md:pl-0
           {:class "py-2.5"
            :scope "col"}
           (tr :calendar.status/name)]
          [:th.pr-3.text-right.text-sm.font-semibold.text-gray-900
           {:class "py-2.5"
            :scope "col"}
           (tr :action/edit)]]]
        [:tbody
         (if (not (empty? (get-in @state [:calendar :eventStatuses])))
           (doall
            (for [[idx event-status] (->> (get-in @state [:calendar :eventStatuses])
                                          (map-indexed vector))]
              ^{:key (str "event-status-" (:id event-status))}
              [:tr.divide-x
               [:td.py-1.px-2.font-semibold.text-sm.flex.items-center
                [tag
                 {:color (:color event-status)}
                 (:name event-status)]]
               [:td.whitespace-nowrap.py-1.pl-2.text-right.text-sm.font-medium.pr-3.w-12
                [:button.text-primary-600.hover:text-primary-900
                 {:type "button"
                  :on-click #(reset! dialog-state {:is-open? true
                                                   :status event-status
                                                   :action :edit})}
                 [:> PencilIcon
                  {:class "h-4 w-4"
                   :aria-hidden true}]]
                [:button.text-primary-600.hover:text-primary-900
                 {:type "button"
                  :on-click #(swap! state assoc-in [:calendar :eventStatuses] (vec-remove (into [] (get-in @state [:calendar :eventStatuses])) idx))}
                 [:> XIcon
                  {:class "h-4 w-4"
                   :aria-hidden true}]]]]))
           [:tr.divide-x
            [:td.py-1.px-2.text-sm.flex.items-center
             {:scope "row"
              :colSpan 2}
             "No Status"]])]]]]

     [:div.space-y-1.sm:grid.sm:grid-cols-3.sm:gap-4.sm:space-y-0.mt-3
      [button
       {:on-click #(do
                     (re-frame/dispatch
                      (case (:action @state)
                        :add [::calendar-events/create-calendar {:calendar (:calendar @state)}]
                        :delete [::calendar-events/delete-calendar {:calendar (:calendar @state)}]
                        :edit [::calendar-events/update-calendar {:calendar (:calendar @state)}]
                        ""))
                     (reset! state {:is-open? false
                                    :calendar nil
                                    :action nil}))}
       (case (:action @state)
         :add (tr :action/create)
         :delete (tr :action/delete)
         :edit (tr :action/save)
         "")]]]))

(defn dialog-content
  [{:keys [state drawer-state]}]
  [:div
   (if (some? (:tag @state))
     ;; Tag
     [:div.relative.mt-6.flex-1.px-4.sm:px-6
      [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
       [:div
        [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
         (tr :calendar.tag/id)]]
       [:div.sm:col-span-3
        [input
         {:auto-complete "id"
          :name "id"
          :disabled? (= (:action @state) :edit)
          :type "text"
          :default-value (get-in @state [:tag :id])
          :on-change #(swap! state assoc-in [:tag :id] %)}]]]

      [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
       [:div
        [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
         (tr :calendar.tag/name)]]
       [:div.sm:col-span-3
        [input
         {:auto-complete "name"
          :name "name"
          :type "text"
          :default-value (get-in @state [:tag :name])
          :on-change #(swap! state assoc-in [:tag :name] %)}]]]

      [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
       [:div
        [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
         (tr :calendar.tag/nameJp)]]
       [:div.sm:col-span-3
        [input
         {:auto-complete "name"
          :name "name"
          :type "text"
          :default-value (get-in @state [:tag :nameJp])
          :on-change #(swap! state assoc-in [:tag :nameJp] %)}]]]

      [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-3
       [:div
        [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
         (tr :calendar.tag/color)]]
       [:div.sm:col-span-3.flex.space-x-2
        [color-group
         {:class "flex"
          :selected (get-in @state [:tag :color])
          :on-change #(swap! state assoc-in [:tag :color] %)
          :size 4
          :colors (listen ::subs/c)}]]]]
     ;; Status
     [:div.relative.mt-6.flex-1.px-4.sm:px-6
      [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
       [:div
        [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
         (tr :calendar.tag/id)]]
       [:div.sm:col-span-3
        [input
         {:auto-complete "id"
          :name "id"
          :disabled? (= (:action @state) :edit)
          :type "text"
          :default-value (get-in @state [:status :id])
          :on-change #(swap! state assoc-in [:status :id] %)}]]]

      [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
       [:div
        [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
         (tr :calendar.status/name)]]
       [:div.sm:col-span-3
        [input
         {:auto-complete "name"
          :name "name"
          :type "text"
          :default-value (get-in @state [:status :name])
          :on-change #(swap! state assoc-in [:status :name] %)}]]]

      [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
       [:div
        [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
         (tr :calendar.status/nameJp)]]
       [:div.sm:col-span-3
        [input
         {:auto-complete "name"
          :name "name"
          :type "text"
          :default-value (get-in @state [:status :nameJp])
          :on-change #(swap! state assoc-in [:status :nameJp] %)}]]]

      [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-3
       [:div
        [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
         (tr :calendar.status/color)]]
       [:div.sm:col-span-3.flex.space-x-2
        [color-group
         {:class "flex"
          :selected (get-in @state [:status :color])
          :on-change #(swap! state assoc-in [:status :color] %)
          :size 4
          :colors (listen ::subs/colors)}]]]])
   [:div.flex.flex-shrink-0.justify-end.py-4
    [button
     {:on-click
      #(do
         (case (:action @state)
           :add (if (some? (:tag @state))
                  (swap! drawer-state update-in [:calendar :eventTags] conj (:tag @state))
                  (swap! drawer-state update-in [:calendar :eventStatuses] conj (:status @state)))
           :edit (if (some? (:tag @state))
                   (let [tags (get-in @drawer-state [:calendar :eventTags])
                         idx (index-of (map :id tags) (get-in @state [:tag :id]))]
                     (swap! drawer-state assoc-in [:calendar :eventTags idx] (:tag @state)))
                   (let [tags (get-in @drawer-state [:calendar :eventStatuses])
                         idx (index-of (map :id tags) (get-in @state [:status :id]))]
                     (swap! drawer-state assoc-in [:calendar :eventStatuses idx] (:status @state))))
           "")
         (reset! state {:is-open? false
                        :tag nil
                        :status nil}))}
     (case (:action @state)
       :add (tr :action/add)
       :edit (tr :action/save)
       "")]]])

(defn content []
  (let [drawer-state (reagent/atom {:is-open? false
                                    :calendar nil
                                    :action :edit})
        dialog-state (reagent/atom {:is-open? false
                                    :tag nil
                                    :status nil
                                    :action :edit})]
    (fn []
      (let [default-calendar {:name ""
                              :color "red"
                              :organizationId (:id (listen ::subs/organization))
                              :eventTags []
                              :eventStatuses []}]
        [:div
         [drawer
          {:state drawer-state
           :title (case (:action @drawer-state)
                    :add (tr :action/add-fn (tr :calendar))
                    :delete (tr :action/delete-fn (tr :calendar))
                    :edit (tr :action/edit-fn (tr :calendar))
                    "")
           :content [calendar-drawer-content
                     {:state drawer-state
                      :dialog-state dialog-state}]}]
         [dialog
          {:state dialog-state
           :title (case (:action @dialog-state)
                    :add (if (some? (:tag @dialog-state))
                           (tr :action/add-fn (tr :calendar/tag))
                           (tr :action/add-fn (tr :calendar/status)))
                    :edit (if (some? (:tag @dialog-state))
                            (tr :action/edit-fn (tr :calendar/tag))
                            (tr :action/edit-fn (tr :calendar/status)))
                    "")
           :content [dialog-content
                     {:state dialog-state
                      :drawer-state drawer-state}]}]
         [:div.px-4.pt-6
          [:div.sm:flex.sm:items-center
           [:div.sm:flex-auto]
           [:div.mt-4.sm:mt-0.sm:ml-16.sm:flex-none
            [button
             {:on-click #(reset! drawer-state {:is-open? true
                                               :calendar default-calendar
                                               :action :add})}
             (tr :action/add-fn (tr :calendar))]]]]
         [:div.divide-y.divide-gray-200
          [:div.py-6.px-4
           [table
            {:headers [{:title (tr :calendar/color)
                        :key :color
                        :class "w-10"
                        :render-cell (fn [color]
                                       [:div.flex.justify-center
                                        [color-circle
                                         {:color color
                                          :size 6}]])}
                       {:title (tr :calendar/name)
                        :key :name
                        :render-cell (fn [name row]
                                       [:div.flex.flex-col
                                        [:span.font-semibold
                                         name]
                                        [:span.text-gray-500
                                         (:nameJp row)]])}
                       {:title (tr :calendar/status)
                        :key :eventStatuses
                        :render-cell (fn [status]
                                       [:span.ml-2
                                        (count status)])}
                       {:title (tr :calendar/tags)
                        :key :eventTags
                        :render-cell (fn [tags]
                                       [:span.ml-2
                                        (count tags)])}]
             :rows (listen ::subs/calendars)
             :actions [{:name :edit
                        :text (tr :action/edit)
                        :on-click #(reset! drawer-state {:is-open? true
                                                         :calendar %
                                                         :action :edit})}
                       {:name :delete
                        :text (tr :action/delete)
                        :on-click #(reset! drawer-state {:is-open? true
                                                         :calendar %
                                                         :action :delete})}]}]]
          [:div.pt-6.divide-y.divide-gray-200
           [:div.py-4.px-4.flex.justify-end.sm:px-6
            [button
             {:type "submit"}
             (tr :action/save)]]]]]))))
